function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#0052A5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.68
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.715 22.16L.84 22.16.84 15.676M22.455 15.62L22.455 22.16 16.137 22.16M16.081.545L22.455.545 22.455 6.197M.84 6.198L.84.546 6.715.546",
  transform: "translate(0 .295)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#0052A5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.68,
  d: "M3.667 9.969L10.136 9.969 10.136 3.5 3.667 3.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0052A5",
  d: "M5.333 8.248L8.358 8.248 8.358 5.223 5.333 5.223zM14.7 8.248L17.725 8.248 17.725 5.223 14.7 5.223zM5.333 17.669L8.358 17.669 8.358 14.644 5.333 14.644zM14.7 17.669L17.725 17.669 17.725 14.644 14.7 14.644z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#0052A5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.68,
  d: "M3.667 19.391L10.136 19.391 10.136 12.922 3.667 12.922zM12.978 9.969L19.447 9.969 19.447 3.5 12.978 3.5zM12.978 19.391L19.447 19.391 19.447 12.922 12.978 12.922z"
}));

var SvgSafeSafeDolneMenuQrcode = function SvgSafeSafeDolneMenuQrcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafeSafeDolneMenuQrcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SafeSafe-dolne-menu-qrcode.9fba2525.svg";
export { ForwardRef as ReactComponent };